/* eslint-disable camelcase */
/**
 * @author Fernando Ruano
 * @file index.js
 * @description Calendar Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { calendar: calendarEndpoints } = endpoints;

export class CalendarService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get patient appointments list by patient id
   * @param { string } patientId - Patient id.
   * @return { Object } - Get patients list.
   */
  getPatientAppointments = async (patientId) => {
    let url = calendarEndpoints.patientAppointments;
    url = `${url}${patientId}`;
    return this.http.post(url);
  };

  /**
   * Get staff appointment availabilities list
   * @param { number } modalityId - Modality id.
   * @param { number } patientCityId - Patient city id.
   * @param { number } patientId - Patient id.
   * @param { number } quoteTypeId - Quote type id.
   * @param { string } desiredDate - Desired date.
   * @return { Object } - Get availabilities list.
   */
  getAppointmentAvailability = async (
    modalityId,
    patientCityId,
    patientId,
    quoteTypeId,
    desiredDate
  ) => {
    let url = calendarEndpoints.appointmentAvailability;
    url = `${url}?desiredDate=${desiredDate}&modalityId=${modalityId}&patientCityId=${patientCityId}&patientId=${patientId}&quoteTypeId=${quoteTypeId}`;
    return this.http.post(url);
  };

  /**
   * Schedule selected appointment
   * @param { number } capId - Quote id.
   * @param { number } patientId - Patient id.
   * @param { number } typeQuote - Quote type id.
   * @return { Object } - Get scheduled appointment.
   */
  scheduleAppointment = async (capId, patientId, typeQuote) => {
    let url = calendarEndpoints.scheduleAppointment;
    url = `${url}?capId=${capId}&patientId=${patientId}&typeQuote=${typeQuote}`;
    return this.http.post(url);
  };

  /**
   * ReSchedule selected appointment
   * @param { number } capId - New quote id.
   * @param { number } patientId - Patient id.
   * @param { number } quoteId - Current quote id.
   * @param { number } typeQuote - Quote type id.
   * @return { Object } - Get rescheduled appointment.
   */
  reScheduleAppointment = async (capId, patientId, quoteId, typeQuote) => {
    let url = calendarEndpoints.reScheduleAppointment;
    url = `${url}?capId=${capId}&patientId=${patientId}&quoteId=${quoteId}&typeQuote=${typeQuote}`;
    return this.http.post(url);
  };

  /**
   * Cancel selected appointment
   * @param { number } quoteId - Current quote id.
   * @return { Object } -Get canceled appointment.
   */
  cancelAppointment = async (quoteId) => {
    let url = calendarEndpoints.cancelAppointment;
    url = `${url}?quoteId=${quoteId}`;
    return this.http.post(url);
  };

  /**
   * Get AgendaMate Patient Info
   * @param { number } documentNumber - identification number.
   * @param { number } documentTypeId - document type id.
   * @return { Object } - Get patient info.
   */
  getAgendaMatePatient = async (documentNumber, documentTypeId) => {
    let url = calendarEndpoints.getPatient;
    url = `${url}?documentNumber=${documentNumber}&documentTypeId=${documentTypeId}`;
    return this.http.post(url);
  };
}

export default new CalendarService(externalConnector);
